// extracted by mini-css-extract-plugin
module.exports = {"sequence":"SequenceView_sequence__3hT3_","sequenceView":"SequenceView_sequenceView__-glVq","subHeader":"SequenceView_subHeader__1cPj4"};